import _extends from "@babel/runtime/helpers/extends";
import { shape, string } from "prop-types";
import React, { useEffect, useState } from "react";

//Components
import { Link, resourceUrl } from "@magento/venia-ui/lib/drivers";
import { useIntl } from "react-intl";
import FeedbackModal from "../../../../components/FeedbackModal/feedbackModal";
import Image from "../Image";
import { MENU_LINKS_DEFAULT, MENU_LINKS_TAKEAWAY } from "./footer-helper";

//Style
import { mergeClasses } from "@magento/venia-ui/lib/classify";
import defaultClasses from "./footer.module.scss";

//Assets
import b_corp_d_uk from "../../../../assets/images/b-corp/b-corp-d-uk.png";
import b_corp_m_uk from "../../../../assets/images/b-corp/b-corp-m-uk.png";
import { LinkBetween } from "../../../../components/LinkBetween/LinkBetween";
import { isMiscusiMainActive, isOrderActive } from "@Components/LinkBetween/miScusiAndTakeAwayUtils";

// Utils
import { useWindowSize } from "@overrides_venia/peregrine/hooks/useWindowSize";
import { useAppContext } from "@overrides_venia/peregrine/context/app";
var Footer = props => {
  var {
    links,
    type
  } = props;
  var [isModalErrorOpen, setIsModalErrorOpen] = useState(false);
  var [isModalOkOpen, setModalOkOpen] = useState(false);
  var [{
    isPageLoading
  }] = useAppContext();
  var classes = mergeClasses(defaultClasses, props.classes);
  var {
    formatMessage
  } = useIntl();
  var vociMenu = isMiscusiMainActive && MENU_LINKS_DEFAULT || isOrderActive && MENU_LINKS_TAKEAWAY;
  var onlyOneColumn = isOrderActive ? classes.onlyOneColumn : "";
  var {
    isMobile
  } = useWindowSize();
  var BCorpImage = /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.bCorp),
    onClick: () => window.open("https://bcorporation.eu/", "_blank")
  }, /*#__PURE__*/React.createElement(Image, {
    "data-uk-img": true,
    height: isMobile ? "110" : "170",
    width: isMobile ? "200" : "125",
    src: isMobile ? b_corp_m_uk : b_corp_d_uk,
    alt: "Miscusi B-Corp",
    displayPlaceholder: false
  }));
  if (isPageLoading) return null;
  var contactUs = type === "no-link" ? null : /*#__PURE__*/React.createElement("div", {
    className: "uk-flex uk-flex-column ".concat(classes.help)
  }, /*#__PURE__*/React.createElement("h4", {
    className: classes.sectionTitle
  }, formatMessage({
    id: "footer.help.title"
  })), /*#__PURE__*/React.createElement("div", {
    className: "uk-flex ".concat(classes.info)
  }, /*#__PURE__*/React.createElement(LinkBetween, {
    className: classes.link,
    href: resourceUrl(formatMessage({
      id: "url.key.ti_serve_aiuto"
    })),
    toTakeAway: false
  }, /*#__PURE__*/React.createElement("u", null, formatMessage({
    id: "click.here"
  })))));
  var menuList = Array.from(vociMenu ? vociMenu : links, _ref => {
    var [groupKey, linkProps] = _ref;
    var menuItems = Array.from(linkProps, _ref2 => {
      var [text, path] = _ref2;
      var itemKey = "text: ".concat(text, " path:").concat(path);
      var itemId = text.split("-").join("_");
      if (isOrderActive) {
        return /*#__PURE__*/React.createElement("li", {
          key: itemKey,
          className: " ".concat(classes.menuItem, " ").concat(onlyOneColumn)
        }, /*#__PURE__*/React.createElement(LinkBetween, {
          className: classes.link,
          href: resourceUrl(path),
          toTakeAway: false
        }, formatMessage({
          id: "footer.menu.item.".concat(itemId)
        })));
      }
      return /*#__PURE__*/React.createElement("li", {
        key: itemKey,
        className: " ".concat(classes.menuItem, " ").concat(onlyOneColumn)
      }, /*#__PURE__*/React.createElement(Link, {
        className: classes.link,
        to: resourceUrl(path)
      }, formatMessage({
        id: "footer.menu.item.".concat(itemId)
      })));
    });
    return /*#__PURE__*/React.createElement("ul", {
      key: groupKey,
      className: classes.menuList
    }, menuItems, WEBSITE_CODE === "MSCIT" ? /*#__PURE__*/React.createElement("li", {
      key: "text: Relazione Impatto path: /relazione-d-impatto",
      className: " ".concat(classes.menuItem, " ").concat(onlyOneColumn)
    }, /*#__PURE__*/React.createElement(Link, {
      className: classes.link,
      to: resourceUrl("/relazione-d-impatto")
    }, "Relazione Impatto")) : null);
  });
  var menu = type === "no-link" ? null : /*#__PURE__*/React.createElement("div", {
    className: "uk-flex uk-flex-column ".concat(classes.menu)
  }, /*#__PURE__*/React.createElement("h4", {
    className: classes.sectionTitle
  }, formatMessage({
    id: "footer.menu.title"
  })), menuList);
  var modalError = /*#__PURE__*/React.createElement(FeedbackModal, {
    modalId: "modal-feedback-error",
    isModalOpen: isModalErrorOpen,
    onClose: () => {
      setIsModalErrorOpen(false);
    },
    error: true,
    title: "footer.feedback.error.title",
    subtitle: "footer.feedback.error.subtitle"
  });
  var modalSuccess = /*#__PURE__*/React.createElement(FeedbackModal, {
    modalId: "modal-feedback-success",
    isModalOpen: isModalOkOpen,
    onClose: () => {
      () => location.pathname = "/";
    },
    error: false,
    title: "footer.feedback.success.title",
    subtitle: "footer.feedback.success.subtitle"
  });
  return /*#__PURE__*/React.createElement("footer", {
    className: "uk-flex uk-flex-column ".concat(classes.root)
  }, /*#__PURE__*/React.createElement("div", {
    className: "uk-flex uk-flex-column ".concat(classes.navigation)
  }, BCorpImage, !isMobile ? /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.contactUs)
  }, contactUs) : null, /*#__PURE__*/React.createElement("div", null, isMobile ? contactUs : null), menu), /*#__PURE__*/React.createElement("div", {
    className: classes.branding
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.cookieWrapper
  }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(Link, {
    to: resourceUrl("/cookie-policy")
  }, formatMessage({
    id: "footer.menu.item.cookie"
  }))), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(Link, {
    to: resourceUrl("/privacy-policy")
  }, formatMessage({
    id: "footer.menu.item.privacy"
  })))), /*#__PURE__*/React.createElement("p", {
    className: "uk-text-uppercase ".concat(classes.copyright)
  }, "\xA9", " ", formatMessage({
    id: "miscusi.piva",
    defaultMessage: "Miscusi SRL società benefit 2021 P. Iva: IT09677510969"
  })))), modalError, modalSuccess);
};
var FooterWrapper = props => {
  var [footerType, setFooterType] = useState();
  FooterWrapper.switch = setFooterType;
  if (footerType === "hidden") {
    return null;
  } else {
    return /*#__PURE__*/React.createElement(Footer, _extends({}, props, {
      type: footerType
    }));
  }
};
FooterWrapper.switch = () => {};

/**
 *
 * @param {"default"|"takeaway"|"hidden"} onMountType
 * @param {"default"|"takeaway"|"hidden"} onUnmountType
 */
export function useFooterType(onMountType) {
  var onUnmountType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  useEffect(() => {
    FooterWrapper.switch(onMountType);
    return () => FooterWrapper.switch(onUnmountType);
  }, [onMountType, onUnmountType]);
}
export default FooterWrapper;
Footer.defaultProps = {
  links: MENU_LINKS_DEFAULT
};
Footer.propTypes = {
  classes: shape({
    root: string
  })
};